module.exports = __webpack_public_path__ + "static/media/TSC_Cards@3x.f9ec8fdf.png";